/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import { Chip } from "@mui/material";

const getStatusColor = (status) => {
    switch (status) {
      case "accepted":
        return "success";
      case "pending":
        return "warning";
      case "rejected":
        return "error";
      default:
        return "default";
    }
};
  

export default function data({dealerMistakes = [], editAction}) {

    const rows = dealerMistakes.map((mistake) => {
        return {
            mistake: mistake?.type?.name,
            date: new Date(mistake.date).toLocaleDateString(),
            penalty: mistake.penalty?.penaltyAmount ?? "-"
        }
    });


  return {
    columns: [
      { Header: "Mistake", accessor: "mistake", align: "left" },
      { Header: "Date", accessor: "date", align: "left" },
      { Header: "Penalty", accessor: "penalty", align: "left" },
    ],

    rows: rows,
  };
}
